import axios from 'axios';
import { memberIdentificationClient } from 'tradera/utils/http';

export interface SessionStatusCommandResult {
    isCompleted: boolean;
    errors: string[];
}

export const pollSessionStatus = <TRequest>(
    successAction: () => void,
    errorAction: (error: string[]) => void,
    command: string,
): (() => void) => {
    const abortController = new AbortController();
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let retries = 0;

    const poll = () => {
        memberIdentificationClient
            .command<SessionStatusCommandResult, TRequest>(
                command,
                {} as TRequest,
                { signal: abortController.signal },
            )
            .then((response) => {
                if (response == undefined) {
                    throw new Error('Response is undefined');
                }

                const { errors, isCompleted } = response || {};

                if (!isCompleted) {
                    // eslint-disable-next-line better-mutation/no-mutation
                    retries++;

                    if (retries > 10) {
                        errorAction(['ErrorUnavailable']);
                    } else {
                        // eslint-disable-next-line better-mutation/no-mutation
                        timeoutId = setTimeout(poll, 3000);
                    }

                    return;
                }

                if (errors.length > 0) {
                    errorAction(errors);

                    return;
                }

                successAction();
                return;
            })
            .catch((ex) => {
                if (axios.isCancel(ex)) {
                    return;
                }

                errorAction(['ErrorUnavailable']);
            });
    };

    poll();

    // Cleanup function
    return () => {
        abortController.abort();

        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    };
};
